import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, Users, Brain, MessageSquare, Database } from 'lucide-react';
export function FeaturesGrid() {
  const features = [{
    icon: <Phone size={24} data-id="element-212" data-mp="3aer8bt5ycgdh" />,
    title: 'Voice Agents',
    desc: '24/7 phone line. Call and talk. MR handles the rest automatically.'
  }, {
    icon: <Mail size={24} data-id="element-213" data-mp="3ehns3n78aij0" />,
    title: 'Email & Communications',
    desc: 'MR watches every inbox, responds, escalates, and reports — automatically.'
  }, {
    icon: <Users size={24} data-id="element-214" data-mp="35ghcdgcelbqt" />,
    title: 'Self-Managing CRM',
    desc: 'Contacts updated, deals moved, follow-ups sent. No manual entry.'
  }, {
    icon: <MessageSquare size={24} data-id="element-215" data-mp="2vojy20q3m3nv" />,
    title: 'Dedicated Client Lines',
    desc: 'Dedicated numbers for every client relationship. MR handles every call.'
  }, {
    icon: <Brain size={24} data-id="element-216" data-mp="2mof2cnu9otpj" />,
    title: 'Persona Builder',
    desc: 'MR learns your business deeply and never forgets a single detail.'
  }, {
    icon: <Database size={24} data-id="element-217" data-mp="9ofe3pz1jz6u" />,
    title: 'Live Mind Maps',
    desc: 'MR is wired into all your data — CRM, ads, analytics, inbox.'
  }];
  return <>
      {/* Gradient Divider */}
      <div className="h-px bg-gradient-to-r from-transparent via-purple/20 to-transparent" data-id="element-218" data-mp="jmv3noif70e8" />

      <section className="section-padding bg-white relative overflow-hidden" data-id="element-219" data-mp="eqejt6i9786y">
        {/* Subtle Ambient Glow Orbs */}
        <div className="absolute top-0 left-0 w-[600px] h-[600px] bg-purple/5 rounded-full blur-[120px] opacity-30 pointer-events-none" data-id="element-220" data-mp="3n56agaqwtsm8" />
        <div className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-teal/5 rounded-full blur-[120px] opacity-30 pointer-events-none" data-id="element-221" data-mp="p248w7098ll" />

        <div className="inner-container relative z-10" data-id="element-222" data-mp="3s37vh17wc20c">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-223" data-mp="34e5ezwp00f7f">
            <span className="text-purple text-sm font-poppins font-bold uppercase tracking-widest" data-id="element-224" data-mp="34ckhpzbaui5v">
              Capabilities
            </span>
            <h2 className="font-poppins font-extrabold text-4xl md:text-5xl leading-tight mt-4 text-gray-900" data-id="element-225" data-mp="13cpg2cz2g0ic">
              One AI. Every Role.
            </h2>
            <p className="text-lg text-gray-500 mt-4" data-id="element-226" data-mp="18965dai04kx0">
              Replace the team you can't afford. Keep the results you need.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-227" data-mp="1h2ar916mjbft">
            {features.map((feat, i) => <motion.div key={i} initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: i % 4 * 0.1
          }} className="group relative bg-white border border-gray-200 rounded-xl p-5 hover:border-teal/40 hover:shadow-lg hover:shadow-teal/5 transition-all overflow-hidden" data-id="element-228" data-mp="kf65v60vgbuc" data-mpi={i}>
                {/* Shimmer Effect on Hover */}
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-229" data-mp="2eyenhijqol7n">
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-teal/5 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000" data-id="element-230" data-mp="2a4k9mvqtf0gh" />
                </div>

                <div className="relative z-10" data-id="element-231" data-mp="213cbcdoatzme">
                  <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-teal/10 to-purple/10 flex items-center justify-center text-xl mb-3 group-hover:scale-110 transition-transform origin-left" data-id="element-232" data-mp="1w5kj1ijqsbho">
                    {feat.icon}
                  </div>
                  <h3 className="font-poppins font-semibold text-base mb-2 text-gray-900" data-id="element-233" data-mp="3lljytihv8z6a">
                    {feat.title}
                  </h3>
                  <p className="text-gray-500 text-sm leading-relaxed" data-id="element-234" data-mp="3hl004ahn9ni1">
                    {feat.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>
    </>;
}